function Policy() {
	return (
		<div style={{ width: "100%" }}>
			<h3>
				We are committed to handling your personal information in
				accordance with the Privacy Act 1988 (Cth).
			</h3>
			<h4>Why is my personal information being collected? </h4>Your
			personal information is being collected so that we can send you more
			information on an animal/s currently available for adoption. It may
			also be used for purposes such as:
			<br />
			<br />- to market our organisation, products and services to you{" "}
			<br />- to send news, information about our activities and general
			promotional material which we believe may be useful to you <br />-
			to keep you informed of donation appeals, other fundraising, events
			and memberships <br />- education, advocacy and providing
			information about existing and new campaigns <br />- quality control
			and research purposes e.g. asking you to participate in a survey
			about your involvement with us <br />- to provide the best possible
			quality of supporter and client service <br />- to update our
			records and keep your contact details up to date <br />- provide
			insights to our organisation on potential adopters
			<br />
			<br /> Your personal information will be held by RSPCA NSW.
			<h4>To whom will my personal information be disclosed?</h4>Contact
			details are usually disclosed to:
			<br />- our employees, contractors and/or service providers for the
			purposes of operation of our supporter and customer services, and to
			otherwise provide information, products and services to you
			including, without limitation, web hosting providers, IT systems
			administrators, mailing houses, payment processors, data entry
			service providers, electronic network administrators
			<br />- RSPCA appointed marketers such as street and telephone
			marketers
			<br />- suppliers and other third parties with whom we have
			commercial relationships, where this is necessary to provide you
			with a service or product
			<br />
			<br />
			For the sole purpose of processing any payments authorised by you,
			payment method details (such as your credit card details) are
			usually disclosed to our employees, contractors and/or service
			providers including, without limitation, web hosting providers,
			payment processors and data entry service providers.
			<h4>Cookies, Google Analytics and Facebook Custom Audiences</h4> We
			send cookies, or small pieces of information, to your web browser in
			order to collect information on your browsing session. Cookies may
			be used for
			<br />• recording preferences that you specify on our website
			<br />• providing general visitor and customer analytics for
			internal
			<br />• assisting with website analysis and optimisation
			<br />• conducting research to improve our content, products and
			online services
			<br />• assisting with direct marketing • supporting security
			measures, such as requiring you to re-login to the site after your
			account has been inactive for a period of time
			<br />
			<br />
			If you do not wish to receive cookies you may disable these in your
			web browser, however please note that doing so may affect the site’s
			ability to function properly. See the ‘Help’ section of your web
			browser for more information on changing your cookie preferences.
			<br />
			<br /> We use Google Analytics to track visits to our website, and
			use this information to track the effectiveness of our website, like
			visits, length of visit, viewed pages and the technical capabilities
			of our visitors. While this data is mostly anonymous, sometimes we
			will connect it to you, for instance in personalising a webpage, or
			prefilling a form with your details. For more information on our
			analytics tools, read{" "}
			<a
				href="https://policies.google.com/privacy"
				target="_blank"
				rel="noreferrer"
			>
				Google’s Privacy Policy.
			</a>
			<br />
			<br /> We also use tools that tell us when a computer or device has
			visited or accessed our content, and allow us to tailor advertising
			both on our website and through advertising networks on other
			websites based on your visits or behaviour through cookies on your
			device. You can control how cookies are used and for what through
			the settings on your chosen browser. You can also control how your
			information is used with advertisers through the Network Advertising
			Initiative, including opting-out from interest-based advertising{" "}
			<a
				href="https://optout.networkadvertising.org/"
				target="_blank"
				rel="noreferrer"
			>
				(click here).
			</a>
			<br />
			<br />
			If you wish to opt-out of having your web browsing information used
			for remarketing, traffic, demographics and interest reporting
			purposes, you can download and install{" "}
			<a
				href="https://tools.google.com/dlpage/gaoptout/"
				target="_blank"
				rel="noreferrer"
			>
				Google Analytics Opt-out Browser Add-on.
			</a>{" "}
			Removing or rejecting cookies may affect the functionality of our
			website and updates to your web browser may affect the functionality
			of the Google Analytics Opt-out add-on.
			<br />
			<br /> We may use Facebook Custom Audiences to deliver
			advertisements to Website Visitors on Facebook based on information
			we already have such as email address. We also may use information
			associated with Visitor social media accounts, such as demographics
			and other information about an individual to improve our marketing
			efforts. Find out more about Facebook advertising{" "}
			<a
				href="https://www.facebook.com/ads/about/?entry_product=ad_preferences/"
				target="_blank"
				rel="noreferrer"
			>
				here
			</a>{" "}
			or learn more about how to opt out of Facebook Custom Audiences{" "}
			<a
				href="https://www.facebook.com/adpreferences/?entry_product=ad_preferences_delegation/"
				target="_blank"
				rel="noreferrer"
			>
				here.
			</a>{" "}
			<h4>Where can I find more information or your privacy policy? </h4>
			Your privacy is important to us. All personal information which you
			provide to us will be subject to our Privacy Policy. Our Privacy
			Policy is available on our website and details our commitment to
			protecting your personal details and privacy can be found{" "}
			<a
				href="https://www.rspcansw.org.au/privacy-policy/"
				target="_blank"
				rel="noreferrer"
			>
				here.
			</a>
		</div>
	);
}

export default Policy;
